<template>
  <div
    class="person_box"
  >
    <div class="icon_cont">
      <i @click="closeDialog" class="close_cont el-icon-close"></i>
    </div>
    <div class="table_title">{{ title }}</div>
    <div class="top_person">
      <div class="left_box">
        <div class="table_items">
          <div class="table_item">
            <div class="item_label" style="border-top: none">姓名</div>
            <div class="value" style="border-top: none">
              {{ personDetail.name }}
            </div>
          </div>
          <div class="table_item">
            <div class="item_label">性别</div>
            <div class="value">{{ personDetail.sex }}</div>
          </div>
          <div class="table_item">
            <div class="item_label">民族</div>
            <div class="value">{{ personDetail.group }}</div>
          </div>
          <!-- <div class="table_item">
            <div class="item_label">文化程度</div>
            <div class="value">{{ personDetail.educationLevel }}</div>
          </div> -->
          <div class="table_item">
            <div class="item_label">是否临时工</div>
            <div class="value">{{ personDetail.isTemp }}</div>
          </div>
        </div>
        <div class="image">
          <el-image
            style="width: 100%; height: 100%"
            :src="personHeadImageContent ? personHeadImageContent : headImg"
            fit="fill"
          ></el-image>
        </div>
      </div>
      <div
        class="left_message"
        v-for="(item, index) in detailList"
        :key="index"
      >
        <div class="item_label">{{ item }}</div>
        <div class="value">{{ getValue(item) }}</div>
      </div>
    </div>
    <div class="records">
      <div class="records_title">考试记录</div>
      <div class="records_table">
        <div class="table_th">
          <div class="th_item" style="border-left: 1px solid #88c5ff">
            考试名称
          </div>
          <div class="th_item">考试分数</div>
          <div class="th_item">考试状态</div>
        </div>
        <div v-if="examinationData.length == 0" class="empty_data">
          <span>暂无数据</span>
        </div>
        <div v-else class="items_box">
          <div
            class="table_td"
            v-for="(item, index) in examinationData"
            :key="index"
          >
            <div class="td_item" style="border-left: 1px solid #88c5ff">
              {{ item.examName }}
            </div>
            <div class="td_item">{{ item.totalScore }}</div>
            <div
              class="td_item"
              :style="{
                color:
                  item.examStatusStr == '通过'
                    ? '#0DA537'
                    : item.examStatusStr == '未通过'
                    ? '#E33122'
                    : '',
              }"
            >
              {{ item.examStatusStr }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="records">
      <div class="records_title">智能分析</div>
      <div class="records_table">
        <div class="table_th">
          <div class="th_item analy-cont">
            <div v-if="isRequesting" class="f-cc">
              <div
                :style="{
                  backgroundImage: `url(${require('../assets/image/bg_circle.gif')})`,
                  height: '100px',
                }"
                class="analy-img"
              ></div>
              <div class="analy-text">智能分析中...</div>
            </div>
            <div v-else class="f-cc">
              <div class="analy-text">
                <div>
                  {{
                    certStatus == 0
                      ? ""
                      : certStatus == 1
                      ? "特种作业证未过期"
                      : "特种作业证已过期"
                  }}
                </div>
                <div>
                  {{
                    personStatus == 0
                      ? "当前时间在厂"
                      : personStatus == 1
                      ? "当前时间不在厂"
                      : "已退厂"
                  }}
                </div>
              </div>
              <div
                v-if="showGif"
                :style="{
                  backgroundImage: `url(${require('../assets/image/bg_complete_run.gif')})`,
                  height: '100px',
                }"
                class="analy-img"
              ></div>
              <div
                v-else
                :style="{
                  backgroundImage: `url(${require('../assets/image/bg_complete_static.png')})`,
                  height: '100px',
                }"
                class="analy-img"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CockpitService from '../service/index'

export default {
  props: {
    visible: {
      type: Boolean,
      default: () => { return false },
    },
    personId: {
      type: String,
      default: () => { return '' },
    },
  },
  data() {
    return {
      personStatus: '',
      certStatus: '',
      timer: null,
      isRequesting: true,
      showGif: true,
      dialogVisible: true,
      title: '人员基本信息',
      imageURL: '',
      detailList: [
        '人员分类',
        '职务/工种',
        '所属单位',
        '项目名称',
        '联系电话',
        '身份证号',
      ],
      tableData: [],
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 15,
      },
      examinationColumn: [
        {
          prop: 'examName',
          label: '考试名称',
          width: '',
        },
        {
          prop: 'totalScore',
          label: '考试分数',
          width: '',
        },
        {
          prop: 'examStatusStr',
          label: '考试状态',
          width: '',
        },
      ],
      trainColumn: [
        {
          prop: 'courseName',
          label: '课程名称',
          width: '',
        },
        {
          prop: 'sumScore',
          label: '获得学分',
          width: '',
        },
        {
          prop: 'traningStatuStr',
          label: '培训状态',
          width: '',
        },
      ],
      personHeadImageContent: '',
      personDetail: {},
      examinationData: [],
      trainData: [],
      headImg: require('../assets/image/head_sculpture.png'),
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val
        this.personHeadImageContent = ''
        if (val) {
          this.getPersonnelDetail()
          this.togetAnalyse()
        } else if (this.timer) clearTimeout(this.timer)
      },
    },
    personId() {
      this.personHeadImageContent = ''
      this.page.pageNo = 1
      this.getPersonnelDetail()
    },
  },
  methods: {
    tostopGif() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.showGif = false
      }, 400)
    },
    async togetAnalyse() {
      const [err, res] = await CockpitService.reqAnalysePerson({
        idcard: this.personId,
      })
      if (res.code == 0 && res.data.code == 0 && res.data.data) {
        this.certStatus = res.data.data.certStatus
        this.personStatus = res.data.data.personStatus
      }
      this.isRequesting = false
      this.tostopGif()
    },
    getValue(key) {
      switch (key) {
        case '人员分类':
          return this.personDetail.personType
        case '职务/工种':
          return this.personDetail.office
        case '所属单位':
          return this.personDetail.deptName
        case '项目名称':
          return this.personDetail.projectName
        case '联系电话':
          return this.personDetail.phone
        case '身份证号':
          return this.personDetail.idCard
      }
    },
    async getPersonnelDetail() {
      const [err, res] = await CockpitService.getPersonInfo(this.personId)
      if (res && res.code == 0) {
        this.personDetail = res.data
        if (res.data.headImg) {
          const fileRes = await CockpitService.getFileContent({ id: res.data.headImg })
          if (fileRes && fileRes.Code === 1 && fileRes.Data) {
            this.personHeadImageContent = `data:image/jpg;base64,${fileRes.Data.content}`
          }
        }
        this.examinationData = res.data.examination ?? []
        this.trainData = res.data.training ?? []
      }
    },
    closeDialog() {
      this.page.pageNo = 1
      this.dialogVisible = false
      this.showGif = true
      this.$emit('close')
    },
  },
  mounted() {},
  beforeDestroy() {
    this.showGif = true
  },
}
</script>

<style lang="scss" scoped>
.f-cc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.analy-text {
  color: #18eeff;
  margin: 0 4px;
}
.analy-img {
  width: 100px;
  background-size: contain;
  background-repeat: no-repeat;
}
.analy-cont {
  width: 100% !important;
  height: 105px;
  border-left: 1px solid #88c5ff;
}
.person_box {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: var(--dialogBgImg);

  background-position: center 0;
  position: absolute;
  left: 790px;
  top: 0px;
  width: 346px;
  max-height: 714px;
  overflow-x: hidden;
  overflow-y: scroll;
  color: #fff;
  padding-bottom: 8px;
  z-index: 101;
  .icon_cont {
    text-align: right;
    margin: 0px 0px 0 0;
    position: relative;
    height: 9px;
    .el-button {
      padding: 5px !important;
      background: #3fbaff4c !important;
      color: #fff;
    }
    .close_cont {
      position: absolute;
      right: 25px;
      top: 30px;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 2px;
      background: rgba(63, 186, 255, 0.2980392157) !important;
      color: #fff;
      cursor: pointer;
      border: 1px solid #d9d9d9;
    }
  }
  .table_title {
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 24px;
  }
  .top_person {
    width: 93%;
    margin: auto;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid #88c5ff;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    .left_box {
      width: 100%;
      display: flex;
      .table_items {
        width: 66%;
        .table_item {
          display: flex;
          font-size: 14px;
          color: #fff;
          .item_label {
            width: 98px;
            text-align: center;
            line-height: 30px;
            border-right: 1px solid #88c5ff;
            border-top: 1px solid #88c5ff;
          }
          .value {
            flex: 1;
            text-align: center;
            line-height: 30px;
            border-right: 1px solid #88c5ff;
            border-top: 1px solid #88c5ff;
          }
        }
      }
      .image {
        flex: 1;
        height: 123px;
        display: flex;
        align-items: center;
      }
    }
    .left_message {
      display: flex;
      font-size: 14px;
      color: #fff;
      .item_label {
        width: 98px;
        text-align: center;
        line-height: 30px;
        border-right: 1px solid #88c5ff;
        border-top: 1px solid #88c5ff;
      }
      .value {
        flex: 1;
        text-align: center;
        line-height: 30px;
        border-top: 1px solid #88c5ff;
      }
    }
  }
  .records {
    width: 93%;
    margin: auto;
    .records_title {
      width: 100%;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 30px;
      border-right: 1px solid #88c5ff;
      border-left: 1px solid #88c5ff;
    }
    .records_table {
      width: 100%;
      .table_th {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .th_item {
          width: 33.3%;
          text-align: center;
          line-height: 30px;
          border-right: 1px solid #88c5ff;
          border-top: 1px solid #88c5ff;
          border-bottom: 1px solid #88c5ff;
        }
      }
      .items_box {
        max-height: 80px;
        overflow-x: hidden;
        overflow-y: scroll;
      }
      .table_td {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .td_item {
          width: 33.3%;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border-right: 1px solid #88c5ff;
          border-bottom: 1px solid #88c5ff;
        }
      }
      .empty_data {
        width: 100%;
        height: 80px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 80px;
        border: 1px solid #88c5ff;
        border-top: none;
      }
    }
  }
}
.items_box::-webkit-scrollbar {
  background-color: rgba(53, 52, 52, 0) !important;
  width: 0px !important;
}
.items_box::-webkit-scrollbar-thumb {
  background-color: rgba(78, 144, 252, 0.6196078431) !important;
}
.items_box::-webkit-scrollbar-track-piece {
  background: rgba(107, 193, 255, 0.1) !important;
  -webkit-border-radius: 7px !important;
}
.person_box::-webkit-scrollbar {
  background-color: rgba(53, 52, 52, 0) !important;
  width: 0px !important;
}
.person_box::-webkit-scrollbar-thumb {
  background-color: rgba(78, 144, 252, 0.6196078431) !important;
}
.person_box::-webkit-scrollbar-track-piece {
  background: rgba(107, 193, 255, 0.1) !important;
  -webkit-border-radius: 7px !important;
}
::-webkit-scrollbar-track-piece {
  background: #f7f7f7;
  -webkit-border-radius: 7px;
}
::v-deep .el-form-item {
  width: auto !important;
}
</style>
